export const QUESTION_TYPE = {
    DND: 'clickar',
    WRITTING: 'escribir',
    DROPDOWN: 'dropdown',
}

export const COMPLETAR_SOUNDS = {
    SUBMIT: 'completar-submit',
    HOVER_BUTTON: 'completar-hoverButton',
    LOAD: 'completar-load',
    LOAD_BANK: 'completar-loadBank',
    CLICK: 'completar-click',
    ACTIVE: 'completar-active',
    WRITE: 'completar-write',
    MOVE: 'completar-move',
    HOVER: "completar-hover",
    CORRECT: "completar-correct",
    WRONG: "completar-wrong",
}